import React from 'react';
import { useLocation } from 'react-router-dom';
import { Scale, ShieldCheck } from 'lucide-react';
import { useLanguage } from '../../context/LanguageContext';

export default function LegalPage() {
  const { pathname } = useLocation();
  const { t } = useLanguage();

  const isPrivacy = pathname.includes('privacy');
  const isTerms = pathname.includes('terms');

  const title = isPrivacy
    ? 'Maxfiylik Siyosati (Privacy Policy)'
    : isTerms
    ? 'Foydalanish Shartlari (Terms of Service)'
    : 'Yuridik Ogohlantirish (Legal Disclaimer)';

  return (
    <div className="bg-slate-50 min-h-screen py-16">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white rounded-xl border border-slate-200 p-8 sm:p-12 shadow-sm space-y-6 text-slate-700 text-sm leading-relaxed">
          <div className="border-b border-slate-200 pb-6">
            <span className="text-xs uppercase tracking-wider text-[#b8935a] font-semibold block mb-1">
              Yuridik Hujjatlar
            </span>
            <h1 className="font-serif text-3xl font-bold text-slate-900">{title}</h1>
            <p className="text-xs text-slate-400 mt-2">
              So‘nggi yangilanish: {new Date().getFullYear()} yil
            </p>
          </div>

          {isPrivacy && (
            <div className="space-y-4">
              <h3 className="font-serif font-bold text-slate-900 text-base">1. Umumiy qoidalar va Advokatlik Siri</h3>
              <p>
                «Jizzax Advokatlari» portali o‘z mijozlari va sayt foydalanuvchilarining shaxsiy ma’lumotlari daxlsizligini to‘liq kafolatlaydi. Sayt orqali yuborilgan barcha konsultatsiya arizalari O‘zbekiston Respublikasining «Advokatura to‘g‘risida»gi Qonuniga muvofiq qonuniy advokatlik siri bilan himoyalangan.
              </p>
              <h3 className="font-serif font-bold text-slate-900 text-base">2. Qanday ma’lumotlar yig‘iladi?</h3>
              <p>
                Biz faqat konsultatsiya uchrashuvini tashkil etish va tasdiqlash uchun zarur bo‘lgan ma’lumotlarni (Ism, telefon raqami va murojaat sababi) qabul qilamiz.
              </p>
              <h3 className="font-serif font-bold text-slate-900 text-base">3. Uchinchi shaxslarga berilmaslik kafolati</h3>
              <p>
                Mijozlarning shaxsiy yoki biznes ma’lumotlari hech qanday tijorat yoki reklama maqsadlarida boshqa tashkilotlarga sotilmaydi va berilmaydi.
              </p>
            </div>
          )}

          {isTerms && (
            <div className="space-y-4">
              <h3 className="font-serif font-bold text-slate-900 text-base">1. Saytdan foydalanish tartibi</h3>
              <p>
                Ushbu veb-sayt orqali advokat qabuliga yozilish advokatlar bilan konsultatsiya o‘tkazish bo‘yicha birlamchi arizasini bildiradi. Ariza ma’muriyat tomonidan tasdiqlanganidan so‘ng rasmiy uchrashuv hisoblanadi.
              </p>
              <h3 className="font-serif font-bold text-slate-900 text-base">2. Tomonlarning javobgarligi</h3>
              <p>
                Mijoz bron qilish vaqtida haqiqiy va to‘g‘ri aloqa ma’lumotlarini ko‘rsatish majburiyatini oladi. Uchrashuvga kela olmaslik holatida oldindan ma’lum qilish so‘raladi.
              </p>
            </div>
          )}

          {!isPrivacy && !isTerms && (
            <div className="space-y-4">
              <h3 className="font-serif font-bold text-slate-900 text-base">Yuridik Ogohlantirish (Disclaimer)</h3>
              <p>
                Ushbu veb-saytdagi umumiy ma’lumotlar, maqolalar va tavsiflar faqat ma’lumot berish maqsadiga ega bo‘lib, rasmiy yuridik xulosa yoki sud kafolati hisoblanmaydi. Har bir ish o‘zining individual hujjatlari va faktik holatlariga ko‘ra advokat tomonidan alohida o‘rganiladi.
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
